export const enum EChartDashboardViewMode {
  CLASSIC = 'classic',
  EXPERT = 'expert',
}

export type TChartDashboardSetting = {
  viewMode: EChartDashboardViewMode,
};
